import { authUserResponseSchema } from '@/features/auth/services/schemas.ts';
import { ApiClient } from '@/common/api/ApiClient.ts';

export const UserService = {
  getCurrentUser: async () => {
    return await ApiClient.get('/user', authUserResponseSchema);
  },
};
